// Angular
import { NgModule } from '@angular/core';

// Pipes
import { MomentPipe } from './moment.pipe';
import { ReplacePipe } from './replace.pipe';
import { CapitalizePipe } from './capitalize.pipe';
import { FormatNumberPipe } from './formatnumber.pipe';
import { SafePipe } from './safe.pipe';
import { NoZeroPipe } from './no-zero-price.pipe';
import { TitleCasePipe } from './titleCase.pipe';
import { CurrencyPipe } from '@angular/common';

const PIPES = [CapitalizePipe, MomentPipe, ReplacePipe, FormatNumberPipe, SafePipe, NoZeroPipe, TitleCasePipe];

@NgModule({
    declarations: PIPES,
    exports: PIPES,
})
export class PipesModule {}
